import React, { useState } from "react";
import Slider from "react-slick";
import "./SliderStyles.css";
import { Button, Container, Dialog, DialogContent, Typography } from "@mui/material";
import img1 from "../../assets/image/1.png";
import img2 from "../../assets/image/2.png";
import img3 from "../../assets/image/3.png";
import img4 from "../../assets/image/4.png";
import img5 from "../../assets/image/5.png";
import QuoteForm from "./QuoteForm";

const SlickSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };
const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const slides = [
    {
      id: 1,
      title: "Custom Website Development",
      img: img1,
      desc: "Automate your business and advance your growth with next-gen AI development solutions from Suffescom",
    },
    {
      id: 2,
      title: "Social Media Marketing",
      img: img2,
      desc: "Automate your business and advance your growth with next-gen AI development solutions from Suffescom. ",
    },
    {
      id: 3,
      title: "Digital Marketing Services",
      img: img3,
      desc: "Join the decentralized world of high security, transparency and efficiency with our blockchain development solutions. ",
    },
    {
      id: 4,
      title: "Marketing Project Services",
      img: img4,
      desc: "Join the decentralized world of high security, transparency and efficiency with our blockchain development solutions. ",
    },
    {
      id: 5,
      title: "Hybrid App Development",
      img: img5,
      desc: "Join the decentralized world of high security, transparency and efficiency with our blockchain development solutions. ",
    },
  ];

  return (
    <div
      className="slick-slider-container"
      style={{ padding: "0px 2px 9px 3px" }}
    >
      <Slider
        {...settings}
        style={{
          backgroundImage:
            'url("https://suffescom.co/assets/images/suffescom-co-banner.webp")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          paddingBottom: "13px",
        }}
      >
        {slides.map((slide, index) => (
          <Container key={index} className="slider_container">
            <div className="slider-item" style={{ minHeight: "600px" }}>
              {/* Left side: Text */}
              <div className="slider-left">
                <Typography
                  variant="h1"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    fontSize: {
                      xs: "38px",
                      md: "55px",
                    },
                  }}
                >
                  {slide.title}
                </Typography>

                <p>{slide.desc}</p>
                <img
                  src="https://suffescom.co/assets/images/suffescom-clients-review-banner.webp"
                  alt="review"
                />
                <div style={{ paddingTop: "10px" }}>
                  <Button
                    variant="contained"
                    onClick={handleClickOpen}
                    sx={{
                      color: "primary",
                      borderRadius: "40px",
                      fontWeight: "bold",
                      background:
                        "linear-gradient(to right, #2D0B5A, #C106A3)",
                      padding: {
                        md: "14px 40px",
                      },
                    }}
                  >
                    Talk To Experts Now
                  </Button>
                </div>
              </div>

              {/* Right side: Image */}
              <div className="slider-right">
                <img
                  src={slide.img}
                  alt={slide.title}
                  style={{
                    width: "auto",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </div>
            </div>
          </Container>
        ))}
      </Slider>
      {/* Form Modal */}
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <DialogContent>
          <QuoteForm />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SlickSlider;
